import { render, staticRenderFns } from "./ProcessDataOrgChart.vue?vue&type=template&id=46a1812a"
import script from "./ProcessDataOrgChart.vue?vue&type=script&lang=js"
export * from "./ProcessDataOrgChart.vue?vue&type=script&lang=js"
import style0 from "./ProcessDataOrgChart.vue?vue&type=style&index=0&id=46a1812a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports